import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { CpRootNode, Json } from '@se/cp.common';
import { Addendum } from '@se/platform';
import { ButtonClick } from '@se/se.ui.html5';

import { PropertyType } from '../cp-configuration/view-model';
import { CpFlatNode, CpNodeFilter, CpNodeFilterStatuses } from '../cp-node';
import { CpDialogState, CpPageState } from './cp.state';

export const cpAddNodes = createAction('[Cp] AddNodes', props<{ nodes: CpFlatNode[]; parentId: string }>());

export const cpAddNodesToRoot = createAction('[Cp] AddNodesToRoot', props<{ nodes: CpFlatNode[] }>());

export const cpApplyCalculations = createAction('[Cp] ApplyCalculations');

export const cpApplyNormalValues = createAction('[Cp] ApplyNormalValues', props<{ notifySuccess?: true }>());

export const cpDialogButtonClick = createAction('[Cp] DialogButtonClick', props<{ button: ButtonClick }>());

export const cpEmpty = createAction('[Cp] EMPTY');

export const cpFilterNodes = createAction('[Cp] FilterNodes', props<{ filter: CpNodeFilter }>());

export const cpFilterTextChange = createAction('[Cp] FilterTextChange', props<{ text: string }>());

export const cpInitialize = createAction('[Cp] Initialize', props<{ page: CpPageState; isPreview?: boolean }>());

export const cpInitializeNodes = createAction(
    '[Cp] InitializeNodes',
    props<{ nodes: CpFlatNode[]; rootNode?: CpRootNode }>(),
);

export const cpNavSelectNode = createAction('[Cp] NavSelectNode', props<{ id: string }>());

export const cpOpenImagesForCurrentExamination = createAction('[Cp] OpenImagesForCurrentExamination');

export const cpOpenLinkedEcgs = createAction('[Cp] OpenLinkedEcgs');

export const cpRemoveNodes = createAction('[Cp] RemoveNodes', props<{ nodes: string[] }>());

export const cpPatchModel = createAction('[Cp] PatchModel', props<{ patches: Record<string, PropertyType> }>());

export const cpSafeExit = createAction('[Cp] SafeExit');

export const cpSelectNode = createAction('[Cp] SelectNode', props<{ id: string }>());

export const cpSetDialogConfig = createAction('[Cp] SetDialogConfig', props<{ config: Partial<CpDialogState> }>());

export const cpSetModel = createAction('[Cp] SetModel', props<{ model: Json }>());

export const cpShowErrorModal = createAction('[Cp] ShowErrorModal', props<{ message: string; title: string }>());

export const cpShowWarningModal = createAction('[Cp] ShowErrorModal', props<{ message: string; title: string }>());

export const cpToggleFilterButton = createAction(
    '[Cp] ToggleFilterButton',
    props<{ status: keyof CpNodeFilterStatuses }>(),
);

export const cpUpdateAllNodes = createAction('[Cp] UpdateAllNodes', props<Partial<CpFlatNode>>());

export const cpUpdateDialogConfig = createAction(
    '[Cp] UpdateDialogConfig',
    props<{ config: Partial<CpDialogState> }>(),
);

export const cpUpdateNode = createAction('[Cp] UpdateNode', props<Update<CpFlatNode>>());

export const cpUpdateNodes = createAction('[Cp] EditNodes', props<{ nodes: Update<CpFlatNode>[] }>());

// #region Toolbar Actions

export const cpApprove = createAction('[Cp] Approve', props<{ useExamService?: boolean }>());

export const cpApproveAddendum = createAction(
    '[Cp] ApproveAddendum',
    props<{ addendum?: Addendum; referringPhysician?: any }>(),
); // !!!! FIXME any

export const cpApproveSaving = createAction('[Cp] ApproveSaving', props<{ useExamService?: boolean }>());

export const cpNavigationBack = createAction('[Cp] NavigationBack', props<{ requestConfirmation?: boolean }>());

export const cpSave = createAction('[Cp] Save', props<{ forcedReload?: boolean; useExamService?: boolean }>());

export const cpSaveCompleted = createAction('[Cp] SaveCompleted', props<{ error: boolean }>());

export const cpSign = createAction(
    '[Cp] Sign',
    props<{ print?: boolean; addendum?: Addendum; referringPhysician?: any }>(),
); // !!!! FIXME any

export const cpUndoValidation = createAction('[Cp] UndoValidation');

export const cpObscurationEditRequest = createAction('[Cp] ObscurationEditRequest');

// #endregion

export const cpClinicalEvaluationMessage = createAction(
    '[Cp] cpClinicalEvaluationMessage',
    props<{ binding: string; warning: string | null; suggestion: string | null }>(),
);

export const cpAskClinicalEvaluationMessage = createAction(
    '[Cp] cpAskClinicalEvaluationMessage',
    props<{ binding: string }>(),
);
